import types from './types';

const InitialState = {
    error: null,
    buttons: {
        auth: false,
        guest: false
    }
}

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.error:
            return {
                ...state,
                error: payload
            }
        case types.toggleButton:
            return {
                ...state,
                buttons: {
                    ...state.buttons,
                    [payload]: !state.buttons[payload]
                }
            }
        default:
            return state;
    }
}